import React, { FC } from 'react'

const MicrophoneIcon: FC<{
    className?: string
}> = ({ className = '' }) => (
    <svg
        width={18}
        height={18}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M9 14.0625C11.4853 14.0625 13.5 12.0478 13.5 9.5625V8.4375M9 14.0625C6.51472 14.0625 4.5 12.0478 4.5 9.5625V8.4375M9 14.0625V16.875M6.1875 16.875H11.8125M9 11.8125C7.75736 11.8125 6.75 10.8051 6.75 9.5625V3.375C6.75 2.13236 7.75736 1.125 9 1.125C10.2426 1.125 11.25 2.13236 11.25 3.375V9.5625C11.25 10.8051 10.2426 11.8125 9 11.8125Z"
            stroke="#31353D"
            strokeWidth={1.125}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default MicrophoneIcon
